import { AuthService } from "src/app/core/endpoints/auth.service";
import { Utils } from "src/app/app.utils";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AppConfig } from "src/app/api/appconfig";
import { ApiService } from "src/app/core/services/api.service";
import { NotificationService } from "src/app/service/notification.service";
import { environment } from "src/environments/environment";
import { ToastService } from "src/app/core/services/toast.service";

@Component({
	templateUrl: "./import.component.html",
	styleUrls: ["./import.component.scss"],
})
export class ImportComponent implements OnInit {
	public loading = false;
	public chartOptions: any;
	public config: AppConfig;
	public location: any;
	public stringLocation: any;
	public locationGps: any;
	public data: any;
	versionApp:any = "";
	@ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;


	constructor(
		public utils: Utils, 
		private apiService: ApiService,
		public notificationService: NotificationService,
		public toastService: ToastService
	) {
		this.getImportData();
	}

	ngOnInit() {
		this.versionApp = localStorage.getItem('versionApp');
		this.notificationService.requestPermission();
	}
	
	loadVersion(){
		this.apiService.getEntity('version').subscribe({
		  next: (response) => {
			this.versionApp = response;
			localStorage.setItem('versionApp',this.versionApp);
		  }
		});
	}

	getUser() {
		return AuthService.getDataUser();
	}

	getAuthToken() {
		return AuthService.getAuthToken();
	}

	public getImportData() {
		this.loading = true;
		this.apiService.getEntity("dashboardAll").subscribe({
			next: async (data) => {
				this.data = data;
				this.loading = false;
			},
			error: (error) => {
				console.log(error);
				this.loading = false;
			},
			complete: () => {
				this.loading = false;
			},
		});
	}
	
	export(type=0){
		var action = 'export';
		if (type === 1){
			action = 'exportUsers';
		}
		if (type === 2){
			action = 'exportCodes';
		}
		if (type === 3){
			action = 'exportInvestments';
		}
		if (type === 4){
			action = 'exportTransactions';
		}
		var token = this.getAuthToken();
		var url = environment.api.url + action +'?token='+token;
		window.open(url,'_blank');
	}

	import(){
    	this.fileInput.nativeElement.value = '';
    	this.fileInput.nativeElement.click();

	}

	onFileSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		if (!input.files || input.files.length === 0) {
		return;
		}
		const file = input.files[0];
		if (!file.name.endsWith('.xlsx')) {
		this.toastService.show('Solo se permiten archivos .xlsx','','error');
		return;
		}

		const formData = new FormData();
		formData.append('file', file);
		formData.append('token', this.getAuthToken());

		this.loading = true;
		this.apiService.addEntity('import', formData).subscribe({
		next: res => {
			this.toastService.show('Importación exitosa','','success');
			this.getImportData();
			this.loading = false;
		},
		error: err => {
			var message = '';
			if (err.error.message){
				message = err.error.message;
			}
			this.toastService.show('Error en la importación ' + message,'','error');
			this.loading = false;
		}
		});
	}
}
